export default {
  familyName: 'Barlow',
  fullName: 'Barlow Regular',
  postscriptName: 'Barlow-Regular',
  category: 'sans-serif',
  capHeight: 700,
  ascent: 1000,
  descent: -200,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 506,
  xWidthAvg: 431,
  subsets: {
    latin: {
      xWidthAvg: 431
    },
    thai: {
      xWidthAvg: 419
    }
  }
};
